// extracted by mini-css-extract-plugin
export default {"date":"xf1yN","description":"CYoiq","asosWorldBox":"uSKaD","icon":"pNtUB"};